import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { Col } from "bootstrap-4-react";
import React, { Component } from "react";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/css/DashboardComponents/ActivityFeed.css";

class ActivityFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenWidth: "",
    };
  }

  componentDidMount() {
    this.setState({ screenWidth: window.innerWidth });
  }

  render() {
    const settings = {
      dots: false,
      infinite: true,
      arrows: true,
      speed: 500,
      slidesToShow:
        this.state.screenWidth < 476 ? 1 : this.state.screenWidth < 992 ? 2 : 4,
      slidesToScroll: 1,
    };

    return (
      <div className="headerCardRoot">
        <div className="headerCardMain">
          <div className="userHeaderCardTitle">
            <span>Activity feed</span> <span> (Under construction)</span>
          </div>
          <div className="adminHeaderCardBody">
            <Slider {...settings}>
              <Col col="sm-12 md-12 lg-12" className="carouselPaddingTop">
                <div className="smallFont">
                  <span>
                    Job: 17, status was changed from Verify to Completed by
                    admin
                  </span>
                  <div className="reviewSec">
                    <span className="reviewPersonName">5 hrs ago</span>
                  </div>
                </div>
              </Col>
              <Col col="sm-12 md-12 lg-12" className="carouselPaddingTop">
                <div className="smallFont">
                  <span>
                    Job: 18, status was changed from Verify to Completed by
                    admin
                  </span>
                  <div className="reviewSec">
                    <span className="reviewPersonName">5 hrs ago</span>
                  </div>
                </div>
              </Col>
              <Col col="sm-12 md-12 lg-12" className="carouselPaddingTop">
                <div className="smallFont">
                  <span>
                    Job: 19, status was changed from Verify to Completed by
                    admin
                  </span>
                  <div className="reviewSec">
                    <span className="reviewPersonName">5 hrs ago</span>
                  </div>
                </div>
              </Col>
              <Col col="sm-12 md-12 lg-12" className="carouselPaddingTop">
                <div className="smallFont">
                  <span>
                    Job: 20, status was changed from Verify to Completed by
                    admin
                  </span>
                  <div className="reviewSec">
                    <span className="reviewPersonName">5 hrs ago</span>
                  </div>
                </div>
              </Col>
              <Col col="sm-12 md-12 lg-12" className="carouselPaddingTop">
                <div className="smallFont">
                  <span>
                    Job: 21, status was changed from Verify to Completed by
                    admin
                  </span>
                  <div className="reviewSec">
                    <span className="reviewPersonName">5 hrs ago</span>
                  </div>
                </div>
              </Col>
              <Col col="sm-12 md-12 lg-12" className="carouselPaddingTop">
                <div className="smallFont">
                  <span>
                    Job: 22, status was changed from Verify to Completed by
                    admin
                  </span>
                  <div className="reviewSec">
                    <span className="reviewPersonName">5 hrs ago</span>
                  </div>
                </div>
              </Col>
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}

export default ActivityFeed;



// WEBPACK FOOTER //
// ./src/components/DashboardComponents/ActivityFeed.js